import { Tabs } from 'antd'
import React, { FunctionComponent, useMemo, useRef } from 'react'

import {
  LUSTRATION_TAB_KEYS,
  MonitoringInputType,
} from '../../common/cuzkMonitorTypes'
import { CuzkMonitorRcCreateTour } from '../components/CuzkMonitorRcCreateTour/CuzkMonitorRcCreateTour'
import { IcoInput } from '../components/IcoInput/IcoInput'
import { NameBirthdateBulkInput } from '../components/NameBirthdateBulkInput/NameBirthdateBulkInput'
import { NameBirthdateInput } from '../components/NameBirthdateInput/NameBirthdateInput'
import { PageLayout } from '../components/PageLayout/PageLayout'
import { RcInput } from '../components/RcInput/RcInput'
import { TabItem, tabsProps } from '../utils/tabsHelpers'
import { useTabKeyState } from '../utils/useTabKeyState'

export const CuzkMonitorRcCreate: FunctionComponent = () => {
  const [activeTabKey, setActiveTabKey] = useTabKeyState<LUSTRATION_TAB_KEYS>(
    LUSTRATION_TAB_KEYS.RC
  )

  const elementRef = {
    rcInput: useRef(null),
    rcSubmit: useRef(null),
    icoInput: useRef(null),
    icoSubmit: useRef(null),
    icoTab: useRef(null),
    nameTab: useRef(null),
    nameInput: useRef(null),
    nameSubmit: useRef(null),
    nameBulkTab: useRef(null),
    nameBulkInput: useRef(null),
    nameBulkSubmit: useRef(null),
  }

  const tabItems = useMemo<TabItem<LUSTRATION_TAB_KEYS>[]>(
    () => [
      {
        key: LUSTRATION_TAB_KEYS.RC,
        label: 'Podle rodného čísla',
        children: (
          <div className="bg-white p-6">
            <RcInput
              type={MonitoringInputType.CuzkRc}
              inputRef={elementRef.rcInput}
              buttonRef={elementRef.rcSubmit}
            />
          </div>
        ),
      },
      {
        key: LUSTRATION_TAB_KEYS.ICO,
        label: <div ref={elementRef.icoTab}>Podle IČO</div>,
        children: (
          <div className="bg-white p-6">
            <IcoInput
              inputRef={elementRef.icoInput}
              buttonRef={elementRef.icoSubmit}
              type={MonitoringInputType.CuzkIco}
            />
          </div>
        ),
      },
      {
        key: LUSTRATION_TAB_KEYS.NAME,
        label: <span ref={elementRef.nameTab}>Podle jména a narození</span>,
        children: (
          <div className="bg-white p-6">
            <NameBirthdateInput
              inputRef={elementRef.nameInput}
              buttonRef={elementRef.nameSubmit}
              type={MonitoringInputType.CuzkName}
            />
          </div>
        ),
      },
      {
        key: LUSTRATION_TAB_KEYS.NAME_BULK,
        label: (
          <span ref={elementRef.nameBulkTab}>
            Hromadně dle jména a narození
          </span>
        ),
        children: (
          <div className="bg-white p-6">
            <NameBirthdateBulkInput
              inputRef={elementRef.nameBulkInput}
              buttonRef={elementRef.nameBulkSubmit}
              type={MonitoringInputType.CuzkName}
            />
          </div>
        ),
      },
    ],
    [
      elementRef.icoInput,
      elementRef.icoSubmit,
      elementRef.icoTab,
      elementRef.nameBulkInput,
      elementRef.nameBulkSubmit,
      elementRef.nameBulkTab,
      elementRef.nameInput,
      elementRef.nameTab,
      elementRef.nameSubmit,
      elementRef.rcInput,
      elementRef.rcSubmit,
    ]
  )

  return (
    <PageLayout title="Vyhledávání subjektů v evidenci ČÚZK" isContainer>
      <Tabs
        {...tabsProps}
        items={tabItems}
        activeKey={activeTabKey}
        onTabClick={setActiveTabKey}
        tabBarExtraContent={
          <CuzkMonitorRcCreateTour
            currentTab={activeTabKey}
            elementRef={elementRef}
          />
        }
      />
    </PageLayout>
  )
}

export default CuzkMonitorRcCreate
